enum OrientationEnum {
	HORIZONTAL = "horizontal",
	VERTICAL = "vertical"
}

export default OrientationEnum;